// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ky4p","col":"styles_col__3T1FR","actions":"styles_actions__3N2op","conflict":"styles_conflict__3fyZ2"};